export const ASAP_AUDIENCE = 'identity-platform';

export const PRODUCT_KEY_MAP = {
  CONFLUENCE: 'confluence.ondemand',
  JIRA_CORE: 'jira-core.ondemand',
  JIRA_BUSINESS: 'jira-core.ondemand',
  JIRA_SOFTWARE: 'jira-software.ondemand',
  JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
  BITBUCKET: 'com.atlassian.bitbucket',
  OPSGENIE: 'opsgenie',
  STATUSPAGE: 'statuspage',
  TRELLO: 'trello'
};

export const IDENTITY_RECAPTCHA_KEY =
  '6Le9VxMnAAAAALKRlj8jmKwUYmFTZWcF0y4o9QeD';

export const IDENTITY_RECAPTCHA_KEY_TEST =
  '6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN';
